(function () {
  const STORAGE_KEY = "country_popup_dismissed_until";
  const DAYS_TO_HIDE = 7; // ocultar 7 días luego de cerrar

  function now() { return Date.now(); }
  function daysToMs(d) { return d * 24 * 60 * 60 * 1000; }

  function shouldShow() {
    try {
      const until = Number(localStorage.getItem(STORAGE_KEY) || "0");
      return now() > until;
    } catch (e) {
      // si localStorage falla, mostramos igual
      return true;
    }
  }

  function hideForDays(days) {
    try {
      localStorage.setItem(STORAGE_KEY, String(now() + daysToMs(days)));
    } catch (e) {}
  }

  function openPopup(overlay) {
    overlay.classList.add("cp-open");
    overlay.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
  }

  function closePopup(overlay) {
    overlay.classList.remove("cp-open");
    overlay.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
    hideForDays(DAYS_TO_HIDE);
  }

  document.addEventListener("DOMContentLoaded", function () {
    const overlay = document.getElementById("CountryPopupOverlay");
    if (!overlay) return;

    const closeButtons = overlay.querySelectorAll("[data-cp-close]");
    const toggleBtn = overlay.querySelector("[data-cp-toggle]");
    const panel = overlay.querySelector("[data-cp-panel]");
    const select = overlay.querySelector("#CountryPopupCountrySelect");

    // Abrir al inicio (si corresponde)
    if (shouldShow()) {
      openPopup(overlay);
    }

    // Cerrar con X y con SHOP NOW
    closeButtons.forEach((btn) => {
      btn.addEventListener("click", function () {
        closePopup(overlay);
      });
    });

    // Cerrar clickeando fuera del modal
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closePopup(overlay);
    });

    // ESC
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && overlay.classList.contains("cp-open")) {
        closePopup(overlay);
      }
    });

    // Toggle dropdown
    if (toggleBtn && panel) {
      toggleBtn.addEventListener("click", function () {
        const isHidden = panel.hasAttribute("hidden");
        if (isHidden) panel.removeAttribute("hidden");
        else panel.setAttribute("hidden", "");
      });
    }

    // Opcional: auto-submit al cambiar país (si lo querés, descomentá)
    // if (select) {
    //   select.addEventListener("change", function () {
    //     const form = overlay.querySelector("#CountryPopupLocalizationForm");
    //     if (form) form.submit();
    //   });
    // }
  });
})();